const state = {
    impersonator: JSON.parse(localStorage.getItem('impersonator')) || null,
}


export const getters = {
    isImpersonating: state => state.impersonator !== null,
    impersonator: state => state.impersonator,
}


export const mutations = {
    resetImpersonator(state) {
        state.impersonator = null
        localStorage.removeItem('impersonator')
    },
    rememberImpersonator(state, {token, jwt}) {
        state.impersonator = {
            token: token,
            jwt: jwt,
        }
        localStorage.setItem('impersonator', JSON.stringify(state.impersonator))
    },
}


export const actions = impersonateService => ({
    async impersonate({commit, dispatch, rootGetters}, user) {
        const response = await impersonateService.impersonate(user.id)

        commit('rememberImpersonator', {
            token: rootGetters['login/token'],
            jwt: rootGetters['login/jwt'],
        })
        commit('login/setToken', {token: response.token, type: 'Token'}, {root: true})
        commit('login/setJwt', response.jwt, {root: true})
        commit('core/resetCache', null, {root: true})
        commit('events/resetState', null, {root: true})
        await dispatch('login/getCurrentUser',true , {root: true})
        window.location.href = '/'
    },
    async returnYourself({commit, getters, dispatch}) {
        const impersonator = getters.impersonator

        commit('login/setToken', impersonator.token, {root: true})
        commit('login/setJwt', impersonator.jwt, {root: true})
        commit('core/resetCache', null, {root: true})
        commit('events/resetState', null, {root: true})

        await dispatch('login/getCurrentUser',null, {root: true})
        commit('resetImpersonator')
        window.location.href = '/'
    }
})

export default impersonateService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(impersonateService)
})

